export default "__VITE_ASSET__1MjoNOd5__"